import React from 'react';
import ReactDOM from 'react-dom/client';
import Warehouse from './pages/Warehouse';
import './warehouse.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Warehouse />
  </React.StrictMode>,
);
